<script setup lang="ts">
import { RowSlot } from '@shared/ui/other'
import { MultiSelectSearchable } from '@shared/ui/fields'

import { useTutorKanbanStore } from '../../model/store'
import { useTutorKanbanSelectReason } from '../../model/tutor-kanban-select-reason.hook'
import { useTutorKanbanReasonConfirm } from '../../model/tutor-kanban-reason-confirm.hook'
import ModalConfirmExitChange from '../modals/ModalConfirmExitChange.vue'

defineOptions({
  name: 'TutorKanbanSelectReason',
})

const {
  isVisible,
  refOptions,
  refValue,
  refMode,
  refResetKey,
  setSelected,
  setDropdownClose,
} = useTutorKanbanSelectReason()

const {
  isConfirmOpen,
  setConfirmChange,
  setCancelChange,
} = useTutorKanbanReasonConfirm()

const tutorKanbanStore = useTutorKanbanStore()
</script>

<template>
  <RowSlot
    v-if="isVisible"
    label="Stage reason"
    required
  >
    <MultiSelectSearchable
      :key="`${tutorKanbanStore.getStage}-${refOptions.length}-${refResetKey}`"
      name="stage-reason"
      placeholder="Select stage reason"
      :options="refOptions"
      :value="refValue"
      :mode="refMode"
      reduce-key="value"
      @selected="setSelected"
      @dropdown:close="setDropdownClose"
    />
    <ModalConfirmExitChange
      :show="isConfirmOpen"
      title="You sure you want to change tutor's exit reason?"
      @click:confirm="setConfirmChange"
      @click:cancel="setCancelChange"
    />
  </RowSlot>
</template>
